/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
// material
import { alpha, styled } from '@mui/material/styles';
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Paper,
  MenuList,
  MenuItem,
  Button,
  Link,
  Modal,
  Divider,
  Grid,
  TextField,
  Select,
  Snackbar,
  Alert,
  Tooltip,
  Menu,
  Skeleton,
  Avatar,
  CircularProgress,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
// components
import { useState, useEffect } from 'react';
import { collection, doc, getCountFromServer, getDoc, query, updateDoc } from 'firebase/firestore';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { format } from 'date-fns';
import { parseInt } from 'lodash';
import { LoadingButton } from '@mui/lab';
import { LucideMegaphone } from 'lucide-react';
import useResponsive from '../../hooks/useResponsive';
import { db } from '../../firebase.config';
import Iconify from '../../components/Iconify';
//
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import NotificationsPopover from './NotificationsPopover';
import { Variables } from '../../context/VariableContext';
import CustomButton from '../../components/CustomButton';
import LucideIcon from '../../components/LucideIcon';
import CustomConfirmationModal from '../../components/customModal/confirmModal';
import { useSnackbarV2 } from '../../components/ui/customSnackV2';
import CustomModal from '../../components/customModal/customModal';


// ----------------------------------------------------------------------

const DRAWER_WIDTH = 250;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 64;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: 'white',
  borderBottom: '1px solid gainsboro',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: `90%`, sm: 500 },
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '7px',
  p: 4,
};

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '10px',
    paddingTop: 5,
    paddingBottom: 5,
    marginTop: theme.spacing(1),
    minWidth: 200,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow: 'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 0.5px, rgba(0, 0, 0, 0.1) 0px 5px 10px -3px, rgba(0, 0, 0, 0.05) 0px 2px 4px -1px',

    '& .MuiMenu-list': {
      padding: 5,
      borderRadius: '10px',
    },

    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 15,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:hover': {
        // backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        borderRadius: '10px',
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        borderRadius: '10px',
      },
    },
  },
}));
const menuLinks = [
  {
    label: 'Mes événements',
    href: '/bo/',
    icon: 'mdi-light:calendar',
    icon2: 'CalendarDays',
  },
  {
    label: 'Organisation',
    href: '/organisation/',
    icon: 'uil:setting',
    icon2: 'Building2',
  },
  {
    label: 'Finance',
    href: '/finance',
    icon: 'carbon:finance',
    icon2: 'Landmark',
  },
  {
    label: 'Marketing',
    href: '/marketing',
    icon: 'nimbus:marketing',
    icon2: 'Megaphone',
  }, /*
  {
    label: 'Analyse',
    href: '/marketing', // Change ici si tu as une autre route
    icon: 'ion:analytics-outline',
  }, */
];

export default function DashboardNavbar({ onOpenSidebar }) {
  const [active, setActive] = useState();
  const showSnackbarV2 = useSnackbarV2()
  const { eventID } = useParams();
  // modal de duplication
  const [openDupplicate, setOpenDupplicate] = useState(false);
  const [openClos, setOpenClos] = useState(false);
  const [open, setOpen] = useState(false);
  const [montant, setMontant] = useState();
  const [demande, setDemande] = useState(0);
  const [event, setEvent] = useState();
  const [tmp, setTmp] = useState(0);
  const [load, setLoad] = useState(false);
  const [date, setDate] = useState('');
  const [ticketCount, setTicketCount] = useState(0);
  const navigate = useNavigate();
  const { generalReload, setGeneralReload } = Variables()

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [anchorElApps, setAnchorElApps] = useState(null);
  const openMenuApps = Boolean(anchorElApps);
  const handleOpenMenuApps = (event) => {
    setAnchorElApps(event.currentTarget);
    // setOpenMenu(true);
  };
  const handleCloseMenuApps = (e) => {
    setAnchorElApps(null);
    // setOpenMenu(false);
  };
  const handleClick = (event) => {
    console.log(event.currentTarget);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = (e) => {
    setAnchorEl(null);
    if (e === 0) {
      setOpenDupplicate(true);
    } else if (e === 2) {
      setOpenClos(true);
    }
  };

  const handleOpenDupplicate = (id) => {
    setActive(id);
    setOpenDupplicate(true);
  };

  const handleTimestamp = (e) => {
    const date = e.toDate();
    const tmp = date.toJSON().split('.');
    const t = tmp[0].split('T');
    return t[0];
  };

  // recuperation des données
  useEffect(() => {
    const fetchData = async () => {
      try {
        const id = eventID;
        let e;
        const docRef0 = doc(db, 'evenement', id);
        // setLoading(true);
        const docSnap = await getDoc(docRef0);
        if (docSnap.exists()) {
          e = docSnap.data();
          setEvent(e);
          setTmp(1);
          setDate(handleTimestamp(e.dateDebut));
        }
        // count
        const snapshot = await getCountFromServer(query(collection(db, `evenement/${eventID}/tickets`)));
        setTicketCount(snapshot.data().count);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData().catch(console.error);
  }, [load, generalReload]);
  const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');
  const xlUp = useResponsive('up', 'xl');

  const handleCloseDupplicate = () => {
    setOpenDupplicate(false);
    setResult();
  };
  const handleCloseClos = () => setOpenClos(false);
  //
  const handleChangement = (stat) => {
    console.log(stat);
    try {
      if (stat === 0) {
        handleBrouillon();
      } else if (stat === 1) {
        goLive();
      } else if (stat === 2) {
        handleClos();
      } else if (stat === 3) {
        handleSupp();
      }
    } catch (error) {
      setMsg('Une erreur est survenue ');
      setSeverity('error');
      setOpenSnack(true);
      console.log(error);
    }
    setSeverity('success');
    setMsg('ok');
    setOpenSnack(true);
  };
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState();
  const [resultDetail, setResultDetail] = useState();
  const handleBrouillon = async () => {
    console.log('repasser en mode brouillon');
    try {
      setLoading(true);
      const refEvent = doc(db, `evenement`, eventID);
      const docSnap = await getDoc(refEvent);
      if (docSnap.exists()) {
        await updateDoc(refEvent, {
          status: parseInt(0),
        });
      }
      setResult('done');
      setResultDetail('vous êtes repasser en mode Brouillon');
      handleCloseDupplicate()
      showSnackbarV2('Événement repassé en brouillon', 'success')
    } catch (error) {
      setResult('error');
      showSnackbarV2('Une erreur s\'est produite', 'error')
      console.log(error);
    } finally {
      setLoading(false);
      setLoad(!load);
    }
  };
  const goLive = async () => {
    console.log('go live');
    navigate(`/${eventID}/publish`, { replace: true });
  };

  const handleClos = async () => {
    console.log('cette action est ireversible');
    setLoading(true);
    try {
      const refEvent = doc(db, `evenement`, eventID);
      const docSnap = await getDoc(refEvent);
      if (docSnap.exists()) {
        await updateDoc(refEvent, {
          status: parseInt(2),
        });
      }
      setResult('done');
      setLoading(false);
      setLoad(!load);
      navigate(`/bo`, { replace: true });
    } catch (error) {
      setResult('error');
      setLoading(false);
      setLoad(!load);
      console.log(error);
    }
  };

  const handleSupp = () => {
    console.log('cette action est ireversible');
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };
  const [openSnack, setOpenSnack] = useState(false);
  const [msg, setMsg] = useState('');
  const [severity, setSeverity] = useState('');
  const location = useLocation();
  return (
    <RootStyle>
      <CustomConfirmationModal open={openDupplicate} onClose={handleCloseDupplicate} title={'Repasser en mode brouillon'} description={'Une fois votre évenement en mode brouillon, il ne sera plus visible au public. voulez vous continuer ?'} onConfirm={handleBrouillon} />

      <CustomModal open={openClos} onClose={handleCloseClos} title={'Clore cet évenement'} onConfirm={handleClos}>
        <Stack spacing={2}>
          <Typography color={'text.secondary'}>
            Si votre événement est terminé et que la billetterie est arrêtée, vous pouvez clore cet événement.
          </Typography>

          <Typography color={'text.secondary'}>
            À la suite de la clôture d’un événement : Vous pourrez télécharger la reddition de compte définitive
            depuis la page “Comptabilité” de votre compte Choptonticket Vous ne pourrez plus effectuer de ventes en
            ligne ou en guichet pour cet événement Vous ne pourrez plus faire de demande de remboursement depuis la
            gestion des participants (les demandes en cours seront toujours valides)
          </Typography>

          <Typography color="red" textAlign={'center'}>
            Attention : Cette action est ireversible.
          </Typography>
        </Stack>

      </CustomModal>

      <ToolbarStyle>
        <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary', display: { lg: 'none' } }}>
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>
        <Stack
          direction="row"
          alignItems="center"
          spacing={{ xs: 0.5, sm: 1.5 }}
          divider={<Divider orientation="vertical" flexItem />}
        >
          {/* !event ? (
            <Skeleton sx={{ width: { xs: 60, sm: 300 } }} />
          ) : (
            <Stack direction="row" alignItems="center" spacing={1} width={{ xs: 60, sm: 300 }}>
              <Avatar alt={event.nomEvent} src={event.idVisuel} />
              {smUp && (
                <Typography noWrap fontSize={18} fontWeight={500} color="#304273">
                  {event.nomEvent}
                </Typography>
              )}
            </Stack>
          ) */}
        </Stack>
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ sm: 1.5 }}>

          {!mdUp ? null : (
            <Stack direction="row" textAlign="center" spacing={{ xs: 0.5, sm: 1 }}>
              {menuLinks.map((link) => {
                const isActive = location.pathname.startsWith(link.href);

                return (
                  <Button key={link.label} sx={{
                    color: isActive ? '#5E17EB' : 'text.primary',
                    bgcolor: isActive ? alpha('#5E17EB',0.08) : 'transparent',
                    backdropFilter: "blur(8px)", // flou
                    // backgroundColor: "transparent", // transparent blanc
                    border: "1px solid transparent", // léger contour
                    // boxShadow: "0 4px 20px rgba(0,0,0,0.2)", // ombre moderne
                    borderRadius: "12px",
                    transition: "all 0.3s ease",
                    textTransform: 'initial',
                    "&:hover": {
                      background: "rgba(255, 255, 255, 0.63)",
                      color: 'text.primary',
                      bgcolor: '#f2f2f2',
                      border: "1px solid transparent", // léger contour
                      // transform: "scale(1.025)",
                    },
                  }} href={isActive ? undefined : link.href} size="large" variant="outlined" startIcon={<LucideIcon name={link.icon2} />}>
                    <Typography variant='body1' fontWeight={500} noWrap>{link.label}</Typography>
                  </Button>
                );
              })}
            </Stack>
          )}

          {event && (
            <>
              {event.status === 0 ? (
                <CustomButton onClick={goLive} disabled={(event.idVisuel === '' || ticketCount === 0) ? true : false} type={'primaire'} buttonText={"Publier l'évenement"} />

              ) : (event.status === 1 || event.status === 3) ? (
                <>
                  <Button
                    onClick={handleClick}
                    aria-controls={openMenu ? 'demo-customized-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openMenu ? 'true' : undefined}
                    variant="outlined"
                    disableElevation
                    size='large'
                    startIcon={
                      <LucideIcon name='Globe' color='green'/>
                    }
                    endIcon={<LucideIcon name='ChevronDown' />}
                    sx={{
                      color: 'text.primary',
                      backgroundColor: 'white',
                      border: '1px solid gainsboro',
                      borderRadius: '12px',
                      '&:hover': {
                        backgroundColor: 'white',
                        color: 'black',
                        border: '1px solid gainsboro',
                      },
                    }}
                  >
                    {(event.status === 1 || event.status === 3) ? (
                      <>Publié</>
                    ) : event.status === 0 ? (
                      <>Publier l'évenement</>
                    ) : event.status === 2 ? (
                      <>Clos</>
                    ) : null}
                  </Button>
                  <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{
                      'aria-labelledby': 'demo-customized-button',
                    }}
                    anchorEl={anchorEl}
                    open={openMenu}
                    onClose={handleCloseMenu}
                  >
                    {(event.status !== 1 && event.status !== 3) && (
                      <MenuItem onClick={handleCloseMenu} disableRipple value={1}>
                        Publier cet évenement
                      </MenuItem>
                    )}
                    {event.status !== 0 && (
                      <MenuItem
                        onClick={(e) => {
                          handleCloseMenu(e.target.value);
                        }}
                        disableRipple
                        value={0}
                      >
                        <ListItemIcon>
                          <LucideIcon name={'NotepadTextDashed'} size={20} />
                        </ListItemIcon>
                        Repasser en brouillon
                      </MenuItem>
                    )}
                    {event.status !== 2 && (
                      <MenuItem
                        sx={{ color: 'red' }}
                        onClick={(e) => {
                          handleCloseMenu(e.target.value);
                        }}
                        disableRipple
                        value={2}
                      >
                        <ListItemIcon>
                          <LucideIcon color={'red'} name={'Lock'} size={20} />
                        </ListItemIcon>
                        Clore cet événement
                      </MenuItem>
                    )}
                  </StyledMenu>
                </>
              ) : (
                <Button
                  onClick={handleClick}
                  aria-controls={openMenu ? 'demo-customized-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openMenu ? 'true' : undefined}
                  variant="outlined"
                  disableElevation
                  disabled
                  startIcon={
                    <Iconify icon="bi:dot" sx={{ width: 30, height: 30, alignItems: 'center', color: 'orange' }} />
                  }
                  endIcon={<Iconify icon="mdi:menu-down" sx={{ width: 25, height: 25, alignItems: 'center' }} />}
                  sx={{
                    color: 'text.primary',
                    backgroundColor: 'white',
                    borderRadius: '7px',
                    '&:hover': {
                      backgroundColor: 'white',
                      color: 'text.primary',
                      border: '1px solid black',
                    },
                  }}
                >
                  {(event.status === 1 || event.status === 3) ? (
                    <>Publier</>
                  ) : event.status === 0 ? (
                    <>Publier l'évenement</>
                  ) : event.status === 2 ? (
                    <>Clos</>
                  ) : null}
                </Button>
              )}
            </>
          )}

          <AccountPopover />
        </Stack>

      </ToolbarStyle>

      <Snackbar open={openSnack} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={`${severity}`} sx={{ width: '100%' }}>
          {msg}
        </Alert>
      </Snackbar>
    </RootStyle>
  );
}
